import { DEFAULT_DASHBOARD_SETTINGS } from '@bms/common';
import type { FlavourFeatures } from './types';

export const hospitalityFeatures: FlavourFeatures = {
  hasAccessControl: true,
  hasDashboard: true,
  hasScenes: true,
  hasDND: true,
  hasMUR: true,
  hasOccupancy: true,
  hasHousekeeping: true,
  hasEnergyMeters: false,
  roomCardVariant: 'compact',
  dashboardLayout: 'grid',
  dashboardHierarchy: { ...DEFAULT_DASHBOARD_SETTINGS, hierarchyLayout: 'grouped' },
};
